import { AES, enc } from 'crypto-js';
import { createJSONStorage } from 'zustand/middleware';

const encryptionKey = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;

const encryptData = (data: string) => AES.encrypt(data, encryptionKey).toString();

const decryptData = (encryptedData: string) => {
  try {
    const bytes = AES.decrypt(encryptedData, encryptionKey);
    return bytes.toString(enc.Utf8);
  } catch (error) {
    console.error('Error decrypting data', error);
    return null;
  }
};

const encrypyedStorage = createJSONStorage(() => sessionStorage, {
  reviver: (key, value) => {
    if (typeof value === 'string') {
      const decryptedValue = decryptData(value);
      return decryptedValue !== null ? JSON.parse(decryptedValue) : value;
    }
    return value;
  },
  replacer: (key, value) => {
    if (typeof value === 'object' && value !== null) {
      return encryptData(JSON.stringify(value));
    }
    return value;
  }
});

const JSONStorage = createJSONStorage(() => sessionStorage);

const storage = process.env.STAGE === 'local' || !encryptionKey  ? JSONStorage : encrypyedStorage;

export default storage;
